import { css } from '@primeuix/styled';

export const style = css`
    .p-radiobutton-group {
        display: inline-flex;
    }
`;
